import { render } from "./DigitalWalletSideNav.vue.js?vue&type=template&id=2222d9df!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalWalletSideNav.vue?vue&type=template&id=2222d9df"
import script from "./DigitalWalletSideNav.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalWalletSideNav.vue?vue&type=script&lang=js"
export * from "./DigitalWalletSideNav.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalWalletSideNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/side-nav/DigitalWalletSideNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2222d9df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2222d9df', __exports__)) {
    api.reload('2222d9df', __exports__)
  }
  
  module.hot.accept("./DigitalWalletSideNav.vue.js?vue&type=template&id=2222d9df!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalWalletSideNav.vue?vue&type=template&id=2222d9df", () => {
    api.rerender('2222d9df', render)
  })

}


export default __exports__